import { createContext, useContext } from 'react';
import hr from './hr';
import en from './en';

export type Lang = 'hr' | 'en';
export type TranslationKey = keyof typeof hr;

const translations: Record<Lang, Record<string, string>> = { hr, en };

export const LANG_LABELS: Record<Lang, string> = {
  hr: 'Hrvatski',
  en: 'English',
};

export const LANG_FLAGS: Record<Lang, string> = {
  hr: '\uD83C\uDDED\uD83C\uDDF7',
  en: '\uD83C\uDDEC\uD83C\uDDE7',
};

export const ALL_LANGS: Lang[] = ['hr', 'en'];

export interface I18nContextValue {
  lang: Lang;
  setLang: (lang: Lang) => void;
  t: (key: TranslationKey, params?: Record<string, string | number>) => string;
}

export const I18nContext = createContext<I18nContextValue | null>(null);

export function createTranslator(lang: Lang) {
  return function t(key: TranslationKey, params?: Record<string, string | number>): string {
    let text = translations[lang]?.[key] || translations['hr'][key] || key;
    if (params) {
      for (const [k, v] of Object.entries(params)) {
        text = text.replace(`{${k}}`, String(v));
      }
    }
    return text;
  };
}

export function useI18n(): I18nContextValue {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error('useI18n must be used within I18nProvider');
  return ctx;
}

/** Resolve a translatable menu field for the active language, falling back to
 *  the base (default-language, i.e. Croatian) value when no translation exists. */
export function localizeField(
  i18n: Record<string, string> | null | undefined,
  base: string | null,
  lang: string,
): string {
  return (i18n && i18n[lang]) || base || '';
}
